"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const react_helmet_1 = __importDefault(require("react-helmet"));
const List = ({ match }) => {
    const { path } = match;
    const [companies, setCompanies] = (0, react_1.useState)([]);
    const companiesApi = new api_1.CompanyApi();
    (0, react_1.useEffect)(() => {
        const fetchItems = async () => {
            const { items } = await companiesApi.index();
            setCompanies(items);
        };
        fetchItems();
    }, []);
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Firmen")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Firmen")),
            react_1.default.createElement("div", { className: "mt-4 flex md:mt-0 md:ml-4" },
                react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/add`, className: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" }, "Neue Firma"))),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" },
                react_1.default.createElement("div", { className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" },
                    react_1.default.createElement("div", { className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" },
                        react_1.default.createElement("table", { className: "min-w-full divide-y divide-gray-200" },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Firmenname"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "E-Mail"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Telefonnummer"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Land"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50" },
                                        react_1.default.createElement("span", { className: "sr-only" })))),
                            react_1.default.createElement("tbody", null, companies.map((company) => (react_1.default.createElement("tr", { key: company.id, className: "bg-white" },
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, company.name),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }, company.email_address),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, company.phone_number),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, company.country),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" },
                                    react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/edit/${company.id}`, className: "text-primary-600 hover:text-primary-900" }, "Bearbeiten")))))))))))));
};
exports.default = List;
